import React from "react";
import CyberDashboard from "./a";
import CyberSecurityLanding from "./b";
import LearningDashboard from "./c";
import PathsSection from "./d";
import Cardss from "./e";
import Pagess from "./f";
import FAQ from "./g";

const MainPage = () => {
  return (
    <>
    <main className="bg-gradient-to-br from-red-700 via-black to-blue-800 text-white">
      
        <CyberDashboard />
        <CyberSecurityLanding />
        <LearningDashboard />
      
        <PathsSection />
    
        <Cardss />
      
        <Pagess />
     
        <FAQ />
      
    </main>
    </>
  );
};

export default MainPage;
